import * as yup from 'yup';

export const MAX_QUANTITY = 9999999;

export const createTechnicianJobsValidation = yup.object({
  buildingAddress: yup.string().required('Building Address is required.'),
  // buildingId: yup.string(),
  buildingName: yup.string().required('Building name is required.'),
  drawingMaterial: yup.string().required('Drawing material is required.'),
  frameColor: yup.string().required('Frame Color is required.'),
  jobTitle: yup.string().required('Job Title is required.'),
  logoResolution: yup.string().required('Logo Resolution is required.'),
  logoFiles: yup.array().nullable().min(1, 'At least 1 logo is required.'),
  notes: yup.string().required('Notes is required.'),
  roundedEdge: yup.boolean().required('Edge Style is required.'),
  sizeOfDrawing: yup.string().required('Size of drawing is required.'),
  pricing: yup.number().required('Please enter price for this job.'),
  shippingAddress: yup.string().required('Shipping address is requied.'),
  additionalRequirement: yup.array().of(
    yup.object({
      _id: yup.string().required('Id is required.'),
      title: yup.string().required('Additional title is required.'),
      value: yup.string().required('Additional description is required.'),
    }),
  ),
});

export const updateTechnicianJobsValidation = (hasLogoUrl: boolean) =>
  yup.object({
    buildingAddress: yup.string().required('Building Address is required.'),
    // buildingId: yup.string(),
    buildingName: yup.string().required('Building name is required.'),
    drawingMaterial: yup.string().required('Drawing material is required.'),
    frameColor: yup.string().required('Frame Color is required.'),
    jobTitle: yup.string().required('Job Title is required.'),
    logoResolution: yup.string().required('Logo Resolution is required.'),
    logoFiles: hasLogoUrl
      ? yup.array().nullable().min(0, 'At least 1 logo is required.')
      : yup.array().nullable().min(1, 'At least 1 logo is required.'),
    notes: yup.string().required('Notes is required.'),
    roundedEdge: yup.boolean().required('Edge Style is required.'),
    sizeOfDrawing: yup.string().required('Size of drawing is required.'),
    pricing: yup.number().required('Please enter price for this job.'),
    shippingAddress: yup.string().required('Shipping address is requied.'),
    additionalRequirement: yup.array().of(
      yup.object({
        _id: yup.string().required('Id is required.'),
        title: yup.string().required('Additional title is required.'),
        value: yup.string().required('Additional description is required.'),
      }),
    ),
  });

export const createPrinterJobsValidation = yup.object({
  jobTitle: yup.string().required('Pdf is required.'),
  // printerName: yup.string().required('Printer is required.'),
  notes: yup.string().required('Notes is required.'),
  quantity: yup.array().of(
    yup.object({
      pdfId: yup.string().required('PDF id is required.'),
      quantity: yup
        .number()
        .required('Quantity is required')
        .min(0)
        .max(MAX_QUANTITY),
    }),
  ),
  shippingAddress: yup.string().required('Shipping address is required.'),
  additionalRequirement: yup.array().of(
    yup.object({
      id: yup.string().required('Id is required.'),
      title: yup.string().required('Additional title is required.'),
      value: yup.string().required('Additional description is required.'),
    }),
  ),
});
